import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// Strip markdown formatting from a prompt for plain-text previews
// (list rows, picker summaries). Rendered markdown belongs in
// dedicated viewers — list cells show a prose snippet, so
// `![alt](url)`, tables, headings and emphasis markers are noise.
export function promptPreview(s: string, max: number): string {
  const stripped = s
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " ")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/[*_`~]+/g, "")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/^\s*[-*+]\s+/gm, "")
    .replace(/\|/g, " ")
    .replace(/---+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return stripped.length <= max ? stripped : stripped.slice(0, max - 1).trimEnd() + "…";
}
